<template>
  <div class="clientes">
    <div class="d-flex justify-content-between">
      <div class="input-group mb-3">
        <button v-on:click="handleAdicionar()" class="btn btn-success">
          <font-awesome-icon :icon="['fas', 'plus']" fixed-width class="me-1"/>Adicionar
        </button>
      </div>

      <div class="input-group mb-3">
        <input
            v-on:keyup.enter="handlePesquisa()"
            type="text"
            class="form-control"
            placeholder="Pesquisar"
            aria-label="Pesquisar"
            aria-describedby="button-addon2">
        <button v-on:click="handlePesquisa()" class="btn btn-outline-secondary" type="button" id="button-addon2">
          <font-awesome-icon :icon="['fas', 'search']" fixed-width class="me-1"/>
        </button>
      </div>
    </div>
    <div class="d-flex">
      <table class="table table-sm-pc table-striped table-hover">
        <thead>
          <tr>
            <th width="25">#</th>
            <th>Identificação</th>
            <th width="150">IP</th>
            <th width="80"></th>
          </tr>
          </thead>
          <tbody>
            <tr v-for="bng in listaBngs" :key="bng.id">
              <td scope="row">{{bng.id}}</td>
              <td>{{bng.descricao}}</td>
              <td>{{bng.ip}}</td>
              <td class="text-end">
                <button type="button" v-on:click="handleEditaBng(bng)" class="btn btn-primary btn-sm me-1">
                  <font-awesome-icon :icon="['fas', 'edit']" fixed-width/>
                </button>
                <button type="button" v-on:click="handleRemoveBng(bng)" class="btn btn-danger btn-sm">
                  <font-awesome-icon :icon="['fas', 'times']" fixed-width/>
                </button>
              </td>

            </tr>
          </tbody>
      </table>
    </div>
    <Paginador v-model="paginador" @change-paginacao="onChangePaginacao"/>

    <!-- modal-edita-servidor-bng -->
    <!-- Button trigger modal -->
    <button type="button" class="d-none" data-bs-toggle="modal" data-bs-target="#modal-edita-servidor-bng" id="btn-modal-edita-servidor-bng-abre">
      Launch
    </button>

    <!-- Modal -->
    <div class="modal fade" id="modal-edita-servidor-bng" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog modal-xl modal-fullscreen-margin" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 v-if="!modalBng.data.id" class="modal-title">
              <font-awesome-icon :icon="['fas', 'plus']" fixed-width/>
              Cadastrar novo BNG
            </h5>
            <h5 v-if="!!modalBng.data.id" class="modal-title">
              <font-awesome-icon :icon="['fas', 'pen']" fixed-width/>
              Editando BNG
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-12 col-sm-6 col-lg-3">
                <label class="required">Tipo</label>
                <select v-model="modalBng.data.tipo" class="form-control">
                  <option value="tbAccelPPP">Accel PPP</option>
                  <option value="tbCisco" disabled>Cisco</option>
                  <option value="tbMikrotik">Mikrotik</option>
                </select>
              </div>
              <div class="col-12 col-sm-6 col-lg-3">
                <label class="required">Identificação</label>
                <input type="text" v-model="modalBng.data.descricao" class="form-control">
              </div>
              <div class="col-12 col-sm-6 col-lg-3">
                <label class="required">Endereço IP</label>
                <input type="text" v-model="modalBng.data.ip" class="form-control">
              </div>
              <div class="col-12 col-sm-6 col-lg-3">
                <label class="required">Senha radius</label>
                <input type="text" v-model="modalBng.data.senha_radius" class="form-control">
              </div>
              <div class="col-12 col-sm-6 col-lg-6">
                <label>Pool padrão acesso IPv4</label>
                <select v-model.number="modalBng.data.pool_ipv4_acesso_id" class="form-select">
                  <option value="0">Nenhum</option>
                  <option v-for="pool in listaIPPoolsPorTipo('tiIPv4', 'tgDistribuicao')" :key="pool.id" :value="pool.id">{{pool.descricao}}</option>
                </select>
              </div>
              <div class="col-12 col-sm-6 col-lg-6">
                <label>Pool padrão bloqueio IPv4</label>
                <select v-model.number="modalBng.data.pool_ipv4_bloqueio_id" class="form-select">
                  <option value="0">Nenhum</option>
                  <option v-for="pool in listaIPPoolsPorTipo('tiIPv4', 'tgBloqueio')" :key="pool.id" :value="pool.id">{{pool.descricao}}</option>
                </select>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal" id="btn-modal-edita-servidor-bng-fecha">Fechar</button>
            <button type="button"
                v-if="!modalBng.data.id"
                v-on:click="handlemodalBngCadastrar()"
                v-bind:disabled="!podeSalvarBng()"
                class="btn btn-success">
              Cadastrar
            </button>
            <button type="button"
                v-if="!!modalBng.data.id"
                v-on:click="handlemodalBngSalvar()"
                v-bind:disabled="!podeSalvarBng()"
                class="btn btn-success">
              Salvar
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- modal-edita-servidor-bng -->
  </div>
</template>

<script>
import Paginador from '@/components/Paginador.vue'
import api from '@/modules/api'
import dialogo from '@/modules/dialogo'
import loading from '@/modules/loading'
import clone from '@/modules/clone'
import model from '@/model'

export default {
  name: 'ServidoresBNG',
  components: {
    Paginador,
  },
  data() {
    return {
      /** @type {model.paginador} */
      paginador: clone(model.paginador),
      listaBngs: [],
      listaIPPools: [],
      modalBng: {
        data: {
          id: undefined,
          tipo: '',
          descricao: '',
          ip: '',
          senha_radius: '',
          pool_ipv4_acesso_id: 0,
          pool_ipv4_bloqueio_id: 0,
        },
      }
    }
  },
  methods: {
    carregaIPPools() {
      api.get(`/ip-pools?paginacao.porPagina=-1`).then(res => {
        this.listaIPPools = res.data.itens;
      }).catch(() => {
        setTimeout(() => {
          this.carregaIPPools();
        }, 1000);
      });
    },
    handlePesquisa() {
      loading(true);

      api.get(`/servidores/bng?${this.paginador.requestParams}`).then(res => {
        loading(false);
        this.listaBngs = res.data.itens;
        this.paginador.pagina = res.data.paginacao.pagina;
        this.paginador.totalItens = res.data.paginacao.total;
      }).catch(error => {
        loading(false);
        dialogo.erroHttp(error);
      });
    },

    onChangePaginacao() {
      this.handlePesquisa();
    },

    handleAdicionar() {
      this.resetmodalBng();
      this.abreModalCadastroBng();
    },

    async handleEditaBng(bng) {
      this.resetmodalBng();

      this.modalBng.data = clone(bng);

      this.abreModalCadastroBng();
    },

    handleRemoveBng(bng) {
      dialogo.confirmacao(`Confirma remover o BNG <b>${bng.descricao}</b>?`).then(() => {
        loading(true);

        api.delete(`/servidores/bng/${bng.id}`).then(() => {
          loading(false);

          this.handlePesquisa();
        }).catch(error => {
          loading(false);
          dialogo.erroHttp(error);
        });
      });
    },

    abreModalCadastroBng() {
      document.getElementById('btn-modal-edita-servidor-bng-abre').click();
    },

    resetmodalBng() {
      this.modalBng.data.id = undefined;
      this.modalBng.data.tipo = '';
      this.modalBng.data.descricao = '';
      this.modalBng.data.ip = '';
      this.modalBng.data.senha_radius = '';
      this.modalBng.data.pool_ipv4_acesso_id = 0;
      this.modalBng.data.pool_ipv4_bloqueio_id = 0;
    },

    podeSalvarBng() {
      switch (true) {
        case (!this.modalBng.data.tipo):
        case (this.modalBng.data.descricao.length < 3):
        case (this.modalBng.data.ip.length < 7):
        case (this.modalBng.data.senha_radius.length < 1):
          return false;

        default:
          return true;
      }
    },

    handlemodalBngCadastrar() {
      const sendData = {...this.modalBng.data};

      loading(true);

      api.post('/servidores/bng', sendData).then(() => {
        loading(false);
        document.getElementById('btn-modal-edita-servidor-bng-fecha').click();
        this.handlePesquisa();
      }).catch(error => {
        loading(false);
        dialogo.erroHttp(error);
      });
    },

    handlemodalBngSalvar() {
      const sendData = {...this.modalBng.data};

      sendData.nome = sendData.razao_social;

      loading(true);
      api.put(`/servidores/bng/${sendData.id}`, sendData).then(() => {
        loading(false);
        document.getElementById('btn-modal-edita-servidor-bng-fecha').click();
        this.handlePesquisa();
      }).catch(error => {
        loading(false);
        dialogo.erroHttp(error);
      });
    },

    listaIPPoolsPorTipo(tipoIP, tipoGrupo) {
      const resultado = this.listaIPPools.
          filter(x => (x.tipo_ip === tipoIP && x.tipo_grupo === tipoGrupo));

      return resultado;
    },
  },

  created() {
    this.handlePesquisa();
    this.carregaIPPools();

    // document.getElementById('btn-modal-edita-servidor-bng-fecha').click();
    /*
    setTimeout(() => {
      this.handleAdicionar();

      this.modalBng.data.tipo = 'tbAccelPPP';
      this.modalBng.data.descricao = 'BNG Teste Front';
      this.modalBng.data.senha_radius = '123465';
      this.modalBng.data.pool_ipv4_acesso_id = 0;
      this.modalBng.data.pool_ipv4_bloqueio_id = 0;
    }, 500);
    /* */
  }
}
</script>
